import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = ['Resúmenes de internet que no coinciden con lo que toma tu cátedra', '400 páginas de bibliografía que no llegás a leer', 'Confundís refuerzo negativo con castigo — las dos tópicas — Piaget con Vygotsky', 'Estudiás horas y en el parcial la hoja en blanco te paraliza', 'La noche anterior entrás en pánico', 'El mismo ciclo el próximo cuatrimestre'];
  return <section className="py-14 px-4 max-w-4xl mx-auto pt-[5px] pb-[5px] space-y-[0px]" data-id="element-204">
      <FadeIn data-id="element-205">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-206">
          ¿Cuántas noches más vas a perder así?
        </h2>

        <div className="text-lg md:text-xl text-gray-300 text-center mb-10 space-y-4 max-w-3xl mx-auto" data-id="element-207">
          <p data-id="element-208">
            Elegiste Psicología. Pero nadie te dijo que ibas a pasar las noches
            buscando resúmenes que no encajan, estudiando apuntes con errores y
            llegando al parcial con la sensación de que no sabés nada.
          </p>
          <p className="font-bold text-white text-2xl mt-8" data-id="element-209">
            No es falta de inteligencia.{' '}
            <span className="text-red-400" data-id="element-210">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-211">
        <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-10 shadow-lg" data-id="element-212">
          <ul className="space-y-6" data-id="element-213">
            {pains.map((pain, index) => <li key={index} className="flex gap-4 items-start" data-id="element-214">
                <XCircle className="text-red-500 shrink-0 mt-1" size={24} data-id="element-215" />
                <span className="text-gray-300 text-lg" data-id="element-216">{pain}</span>
              </li>)}
          </ul>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-217">
        <div className="text-center mt-14" data-id="element-218">
          <h3 className="text-3xl md:text-4xl font-bold text-sky-400" data-id="element-219">
            ¿Y si este fuera el último parcial que viviste así?
          </h3>
        </div>
      </FadeIn>
    </section>;
}